import { ArrowUpRight } from "lucide-react";
import { ThreadArt } from "@/components/ThreadArt";

export const ProductCard = ({ product }) => {
  const hasLink = product.etsy_url && product.etsy_url.startsWith("http");
  return (
    <article className="group" data-testid={`product-card-${product.id}`}>
      <div className="relative aspect-[3/4] overflow-hidden border border-white/10">
        {product.image_url ? (
          <img
            src={product.image_url}
            alt={product.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        ) : (
          <ThreadArt
            seed={product.title}
            className="h-full w-full transition-transform duration-700 ease-out group-hover:scale-105"
          />
        )}
        <div className="pointer-events-none absolute inset-0 border border-[#D4AF37]/0 transition-colors duration-500 group-hover:border-[#D4AF37]/40" />
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-serif text-2xl font-light leading-tight" data-testid={`product-title-${product.id}`}>
            {product.title}
          </h3>
          <p className="mt-2 max-w-xs text-sm leading-relaxed text-white/50">{product.description}</p>
        </div>
        <span className="whitespace-nowrap font-serif text-xl text-[#D4AF37]" data-testid={`product-price-${product.id}`}>
          {product.price}
        </span>
      </div>
      {hasLink ? (
        <a
          href={product.etsy_url}
          target="_blank"
          rel="noreferrer"
          data-testid={`product-etsy-${product.id}`}
          className="mt-5 inline-flex items-center gap-2 border border-[#D4AF37]/60 px-6 py-2.5 text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#D4AF37] hover:text-black"
        >
          Shop on Etsy <ArrowUpRight className="h-3.5 w-3.5" />
        </a>
      ) : (
        <span
          data-testid={`product-etsy-pending-${product.id}`}
          className="mt-5 inline-flex items-center gap-2 border border-white/15 px-6 py-2.5 text-[10px] uppercase tracking-[0.25em] text-white/30"
        >
          Etsy link coming soon
        </span>
      )}
    </article>
  );
};

export default ProductCard;
